import * as React from "react";
import Grid from "@material-ui/core/Grid";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import CyPortfolioRiskMetrics from "../../../components/Charts/CyPortfolioRiskMetrics";
import {END_OF_CPR_YEAR} from "../../../utilities/cpr";

const StrategyRiskMetrics = (props) => {
  const { portfolio, baseChartData, bdIsCambridge, accessLevel } = props;
  const { cprRecommendation, metadata } = portfolio;

  const useWbiSingleStrategy = ['WBI Portfolios', 'WBI Envestnet', 'Other Models'].includes(metadata.managerType);
  const managerList = cprRecommendation.managers;
  const strategyStartDate = moment(baseChartData[0].date)
    .startOf("month")
    .subtract(2, "months");
  const dateValue = END_OF_CPR_YEAR.toDate().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <section
      className={"content"}
      data-toc={"Cy Optimized Portfolio Statistics"}
    >
      <Grid container={true} spacing={3}>
        <Grid item={true} xs={12}>
          <Typography variant="h4">
            Cy Optimized Portfolio Statistics
          </Typography>
          <Typography variant="h5" gutterBottom={true}>
            Hypothetical Illustration
          </Typography>
          <Typography variant="h5">
            Let’s review some additional information about the{" "}
            {useWbiSingleStrategy
              ? "selected portfolio"
              : "Cy optimized portfolio and fund or investment strategies"}
            .
          </Typography>
        </Grid>
        <Grid item={true} xs={12} style={{ marginBottom: "0.8in" }}>
          <Typography variant="h5">Risk Metrics</Typography>
          <Typography variant="h6" gutterBottom={true}>
            for the date range ending {dateValue}
          </Typography>
          <CyPortfolioRiskMetrics
            startDate={strategyStartDate.format("MM/DD/YYYY")}
            managerList={managerList}
            portfolioDisplayName={cprRecommendation.displayName || ""}
            portfolioSummary={cprRecommendation.summary}
            useWbiSingleStrategy={useWbiSingleStrategy}
            forPrinting={true}
            bdIsCambridge={bdIsCambridge}
            accessLevel={accessLevel}
          />
        </Grid>
      </Grid>
    </section>
  );
};


export default StrategyRiskMetrics;



// WEBPACK FOOTER //
// ./src/containers/SummaryPDF/components/StrategyRiskMetrics.jsx